import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {Alert, Button, Form, Radio, Spin, Tooltip, Select} from "antd";
import Seperator from "./Seperator";
import CheckboxGroupWithJointCheckAll from "./CheckboxGroupWithJointCheckAll";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";
import useInputs from "../../../utils/hooks/useInputs";
import { StyledButton2 } from "../../../styled-components/Button";
import "./WidgetSearchByUid.scss";
import MapPropsContext from "../MapPropsContext";
import {getPointByMtr} from "../../../api";


const { Option } = Select;
const WidgetCls1 = ({ fetchUrl }) => {
  // const [newmtrCodeValue, setNewmtrCodeValue] = useState();
  const [message, setMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const {
    setMapCenter,
    setClickedPointIconObjects,
  } = useContext(MapPropsContext);

  const {
    widgetState,
    onChangeWidgetState
  } = useContext(MapPropsContext);
  const {field1, field2, field3, field4} = widgetState;

  
  /*
  const onPaste = (e) => {
    const text = (e.clipboardData  || window.clipboardData)
      .getData('text')
      .replace(/[^\d]+/g, '');
    onChange({ target: {
      name: 'field1', value: text.slice(0, 5)
    }});
  };
  */

  const [state, setState] = useState({
    indeterminate: "",
  });

  const on1GubunChange = useCallback((frqGubun) => {
    let fieldName = "field1Gubun";
    const year = parseInt(frqGubun);
    setState({
      indeterminate: frqGubun,
    });
    onChangeWidgetState({
      target: {
        name: fieldName,
        value: frqGubun,
      }}
    );
  }, [options]);

  const on2GubunChange = useCallback((frqGubun) => {
    let fieldName = "field2Gubun";
    const year = parseInt(frqGubun);
    setState({
      indeterminate: frqGubun,
    });
    onChangeWidgetState({
      target: {
        name: fieldName,
        value: frqGubun,
      }}
    );
  }, [options]);

  const on3GubunChange = useCallback((frqGubun) => {
    let fieldName = "field3Gubun";
    const year = parseInt(frqGubun);
    setState({
      indeterminate: frqGubun,
    });
    onChangeWidgetState({
      target: {
        name: fieldName,
        value: frqGubun,
      }}
    );
  }, [options]);

  const on4GubunChange = useCallback((frqGubun) => {
    let fieldName = "field4Gubun";
    const year = parseInt(frqGubun);
    setState({
      indeterminate: frqGubun,
    });
    onChangeWidgetState({
      target: {
        name: fieldName,
        value: frqGubun,
      }}
    );
  }, [options]);

  const options =
  [
    { value: "sLike", name: "포함" },
    { value: "sWhere", name: "동일" },
  ];

  return (
    <div>
      <table>
      <tbody>
        <tr>
          <td>
            <span><h3>신목적사항코드</h3></span>
            <div style={{ float: "left" }}>
            <Select
              defaultValue={"sLike"}
              onChange={on1GubunChange}
              fieldName={"field1Gubun"}
              style={{width: '6em'}}
              placeholder={"검색조건을 선택해주세요."}
            >
              {options
                .map(({name, value}) =>
                  <Select.Option key={name} value={value}>
                    {name}
                  </Select.Option>
                )}
            </Select>
            </div>
            <span className={"ant-input-affix-wrapper"} style={{ border: 0, width: '150px', marginLeft: '8px'}}>
              <Tooltip title={"신목적사항코드를 3자 이상 입력해주세요."} placement={"bottom"}>
                <div className={["uid-field", "ant-input"].join(" ")}>
                  <input type="text"
                      name="field1"
                      maxLength={5}
                      size={5}
                      value={field1}
                      onChange={onChangeWidgetState}
                     //onPaste={onPaste}
                      style={{ border: 0, width: '8.8em' }} />
                </div>
              </Tooltip>
            </span>
            {
              <Button type={"primary"}
                      disabled={!/^\d{3}/g.test(field1) || isLoading}
                      style={{ width: '148px', height: '0%', position: 'absolute', left: '104px', top: '74px'}}>
                {isLoading && <Spin />}
                {!isLoading}
              </Button>
            }
          </td>
          <td>
            &nbsp;&nbsp;&nbsp;
          </td>
          <td>
            <span><h3>지정기준코드</h3></span>
            <div style={{ float: "left" }}>
            <Select
              defaultValue={"sLike"}
              onChange={on2GubunChange}
              fieldName={"field2Gubun"}
              style={{width: '6em'}}
              placeholder={"검색조건을 선택해주세요."}
            >
              {options
                .map(({name, value}) =>
                  <Select.Option key={name} value={value}>
                    {name}
                  </Select.Option>
                )}
            </Select>
            </div>
            <span className={"ant-input-affix-wrapper"} style={{ border: 0, width: '150px', marginLeft: '8px'}}>
              <Tooltip title={"지정기준코드를 4자 이상 입력해주세요."} placement={"bottom"}>
                <div className={["uid-field", "ant-input"].join(" ")}>
                  <input type="text"
                      name="field2"
                      maxLength={10}
                      size={10}
                      value={field2}
                      onChange={onChangeWidgetState}
                      //onPaste={onPaste}
                      style={{ border: 0, width: '8.8em' }} />
                </div>
              </Tooltip>
            </span>
            {
              <Button type={"primary"}
                      disabled={!/^[0-9\\.]{4}/g.test(field2) || isLoading}
                      style={{ width: '148px', height: '0%', position: 'absolute', left: '365px', top: '74px'}}>
                {isLoading && <Spin />}
                {!isLoading}
              </Button>
            }
          </td>
        </tr>

        <tr style ={{ height: '16px' }}>
        </tr>

        <tr>
          <td>
            <Seperator />

            <span><h3>지정용도코드</h3></span>
            <div style={{ float: "left" }}>
            <Select
              defaultValue={"sLike"}
              onChange={on3GubunChange}
              fieldName={"field3Gubun"}
              style={{width: '6em'}}
              placeholder={"검색조건을 선택해주세요."}
            >
              {options
                .map(({name, value}) =>
                  <Select.Option key={name} value={value}>
                    {name}
                  </Select.Option>
                )}
            </Select>
            </div>
            <span className={"ant-input-affix-wrapper"} style={{ border: 0, width: '150px', marginLeft: '8px'}}>
              <Tooltip title={"지정용도코드를 3자 이상 입력해주세요."} placement={"bottom"}>
                <div className={["uid-field", "ant-input"].join(" ")}>
                  <input type="text"
                      name="field3"
                      maxLength={5}
                      size={5}
                      value={field3}
                      onChange={onChangeWidgetState}
                     //onPaste={onPaste}
                      style={{ border: 0, width: '8.8em'}} />
                </div>
              </Tooltip>
            </span>
            {
              <Button type={"primary"}
                      disabled={!/^[a-zA-Z0-9]{3}/g.test(field3) || isLoading}
                      style={{ width: '148px', height: '0%', position: 'absolute', left: '105px', top: '168px'}}>
                {isLoading && <Spin />}
                {!isLoading}
              </Button>
            }
          </td>
          <td>
            &nbsp;&nbsp;&nbsp;
          </td>
          <td>
            <Seperator />

            <span><h3>시설자</h3></span>
            <div style={{ float: "left" }}>
            <Select
              defaultValue={"sLike"}
              onChange={on4GubunChange}
              fieldName={"field4Gubun"}
              style={{width: '6em'}}
              placeholder={"검색조건을 선택해주세요."}
            >
              {options
                .map(({name, value}) =>
                  <Select.Option key={name} value={value}>
                    {name}
                  </Select.Option>
                )}
            </Select>
            </div>
            <span className={"ant-input-affix-wrapper"} style={{ border: 0, width: '150px', marginLeft: '8px'}}>
              <Tooltip title={"시설자를 2자 이상 입력해주세요."} placement={"bottom"}>
                <div className={["uid-field", "ant-input"].join(" ")}>
                  <input type="text"
                      name="field4"
                      maxLength={30}
                      size={30}
                      value={field4}
                      onChange={onChangeWidgetState}
                      //onPaste={onPaste}
                      style={{ border: 0, width: '8.8em'}} />
                </div>
              </Tooltip>
            </span>
            {
              <Button type={"primary"}
                      disabled={!/^.{2,30}/g.test(field4) || isLoading}
                      style={{ width: '148px', height: '0%', position: 'absolute', left: '364px', top: '168px'}}>
                {isLoading && <Spin />}
                {!isLoading}
              </Button>
            }
          </td>
        </tr>

    </tbody>
    </table>
    </div>
  );
}

export default WidgetCls1;